module.exports = __webpack_public_path__ + "img/plan1.ff8efd8b.svg";